<app-shared-loading *ngIf="loading && !showAutoExposedTcForm"></app-shared-loading>
<ng-container *ngIf="showAutoExposedTcForm; else regularTempalte">
  <div class="container mw-50" *ngIf="showAutoExposedTcForm">
    <app-embebed-credit-card [info]="info" [isVisible]="isTcFormVisible"></app-embebed-credit-card>
  </div>
</ng-container>
<ng-template #regularTempalte>
  <div class="container">
    <app-navbar></app-navbar>
    <div class="flexBox">
      <div class="column">
        <app-moneysrc-policy *ngIf="visualizeMoneyPolicy" [countryPolicyData]="policyData" (policySaved)="enablePaymentMethods()"></app-moneysrc-policy>
        <app-pay-methods
          *ngIf="visualizeMethods"
          [isCreditCardUnique]="isCreditCardUnique"
          [flagRedeban]="flagRedeban"
          (cash)="funChangeCash($event)"
          (cc)="funChangeCC($event)"
          (deposit)="funChangeDeposit($event)"
          (transfer)="funChangeTransfer($event)"
          (wallet)="funChangeWallet($event)"
          (transferCRC)="funChangeCash($event)"
          (bnpl)="funChangeBnpl($event)"
          (qrEmitter)="funChangeQrs($event)"
          (subMenuCREmitter)="funSubMenu($event)"
          (subMenuGUEmitter)="funSubMenuGU($event)"
          (peruMethods)="funChangePeruMethods($event)"
          (splitPayment)="funChangeSplitMethods($event)"
          (sinpePayment)="changeToSinpePayments($event)"
          (cdcEmitter)="changeToCdcPayment($event)"
          (listPaymentsEmitter)="setInfoOrderPayments($event)"
          (puntosColombiaPayment)="changeToPuntosColombia($event)"
          (ccNewFlow)="changeToNewCcFlow($event)"
          (preloadEmbebedTcForm)="preloadEmbebedTcForm($event)"
          (apiPayInFormPayment)="changeToApiPayIn($event)"
          (preloadEmbebedApiPayInForm)="preloadEmbebedApiPayInForm($event)"
        ></app-pay-methods>
        <app-cash (CASH)="changeMethod()" *ngIf="visualizeCash" [info]="info" [country]="transaction.ORDER_CURRENCY" [visibleReturnPayMethods]="visibleReturnPayMethods"></app-cash>
        <app-deposit (CASH)="changeMethod()" *ngIf="visualizeDeposit" [info]="info"></app-deposit>
        <app-credit-card (TC)="changeMethod()" *ngIf="visualizeCC" [info]="info"></app-credit-card>
        <app-embebed-credit-card (TC)="changeMethod()" [info]="info?.payment" [wallet]="info?.wallet" *ngIf="visualizeNewCCFlow" [isVisible]="isTcFormVisible"></app-embebed-credit-card>
        <app-pse (PSE)="changeMethod()" *ngIf="methodToVisualice === 'ach'" [info]="info"></app-pse>
        <app-pse-av (AV)="changeMethod()" *ngIf="methodToVisualice === 'av'" [info]="info"></app-pse-av>
        <app-wallet (WALLET)="changeMethod()" *ngIf="visualizeWallet && methodToVisualice === 'bevalida'" [info]="info"></app-wallet>
        <app-yape-peru (YAPE)="changeMethod()" *ngIf="visualizeWallet && methodToVisualice === 'yape'" [info]="info"></app-yape-peru>
        <app-deuna-ecuador (DEUNA)="changeMethod()" *ngIf="deunaCheckoutFF && visualizeWallet && methodToVisualice === 'deuna'" [info]="info"></app-deuna-ecuador>
        <app-transfer-bam (BAM)="changeMethod()" *ngIf="methodToVisualice === 'transfer'" [info]="info"></app-transfer-bam>
        <!-- COMPONENTE PARA BUY NOW PAY LATER (BNPL)  -->
        <app-bnpl (BNPL)="changeMethod()" *ngIf="visualizeBnpl" [info]="info"></app-bnpl>
        <!-- COMPONENT TO NEW ELECTRONIC WALLETS  -->
        <app-pse-wallet (PSE)="changeMethod()" *ngIf="visualizeWallet && methodToVisualice === 'walletPse'" [info]="info"> </app-pse-wallet>
        <!-- COMPONENT TO CLAROPAY WALLET -->
        <app-wallet-claro-pay (CLAROPAY)="changeMethod()" *ngIf="visualizeWallet && methodToVisualice === 'claroPay'" [info]="info"></app-wallet-claro-pay>
        <app-native-daviplata (DAVIPLATA)="changeMethod()" *ngIf="visualizeWallet && methodToVisualice === 'daviplataNative'" [information]="info" [transaction]="transaction"> </app-native-daviplata>
        <!-- COMPONENT QR -->
        <app-qr (outPutQrEmitter)="changeMethod()" *ngIf="visualizeQrs" [info]="info" [transaction]="transaction"></app-qr>
        <app-sub-menu-cr
          *ngIf="visualizeSubMenu"
          [paymentsSubMenu]="paymentsSubMenu"
          [transaction]="transaction"
          [flagActive]="flagSubMenu"
          [visibleReturnPayMethods]="visibleReturnPayMethods"
          (outPutSubMenuEmitter)="changeMethod()"
        ></app-sub-menu-cr>
        <app-footer [itsMobileCtrl]="true" *ngIf="visualizeMethods"></app-footer>

        <app-sub-menu-gu
          *ngIf="visualizeSubMenuGU"
          [paymentsSubMenuGU]="paymentsSubMenuGU"
          [transaction]="transaction"
          [visibleReturnPayMethods]="visibleReturnPayMethods"
          (outPutSubMenuGUEmitter)="changeMethod()"
        ></app-sub-menu-gu>
        <app-footer [itsMobileCtrl]="true" *ngIf="visualizeMethods"></app-footer>

        <app-peru-payment-services *ngIf="visualizePeruMethods" (PERUMETHODS)="changeMethod()" [information]="info" [transaction]="transaction"> </app-peru-payment-services>

        <app-split-payment *ngIf="visualizeSplitMethods" (SPLIT)="changeMethod()" [information]="info" [transaction]="transaction"> </app-split-payment>

        <app-sinpe-movil *ngIf="visualizeSinpeMethods" (SINPE)="changeMethod()" [information]="info" [transaction]="transaction"> </app-sinpe-movil>

        <app-consumer-credit (CDC)="changeMethod()" *ngIf="visualizeCdcMethod" [information]="info" [transaction]="transaction" [infoOrderCheckout]="infoOrderCheckout"> </app-consumer-credit>

        <app-puntos-colombia (PCOL)="changeMethod()" *ngIf="visualizePuntosColombia" [information]="info" [transaction]="transaction"> </app-puntos-colombia>

        <app-embebed-transfiya *ngIf="methodToVisualice === 'transfiya'" (TRANSFIYA)="changeMethod()" [transaction]="transaction" [paymentInfo]="info"></app-embebed-transfiya>

        <app-embebed-api-pay-in *ngIf="visualizeApiPayIn" (APIPAYIN)="changeMethod()" [info]="info" [transaction]="transaction" [isVisible]="isApiPayInFormVisible"> </app-embebed-api-pay-in>
      </div>
      <app-secure></app-secure>
      <div class="column transactionInfo">
        <app-transaction [transaction]="transaction" *ngIf="visualizeTransaction" [orderID]="orderID" [flagActive]="flagSubMenu"></app-transaction>
      </div>
    </div>

    <app-user-form *ngIf="visualizeUserForm" [flagActive]="flagUserForm"> </app-user-form>
  </div>
</ng-template>
